import React from 'react';
import ProductCardGrid from '@repo/ui-components/ProductCardGrid';
import ProductCard from '@repo/ui-components/product-card/ProductCard';

type Variant = {
  sku: string;
  price: number;
};

type ShopifyProduct = {
  title: string;
  variants: Variant[];
};

type Store = {
  previewImageUrl?: string;
};

type Product = {
  shopifyProduct?: ShopifyProduct;
  store?: Store;
};

interface RelatedProductsComponentProps {
  products: Product[];
}

const getResizedProductImage = (image?: string): string | undefined => {
  if (image.includes('.jpg')) {
    return image.replace('.jpg', '_300x.jpg');
  }
  if (image.includes('.png')) {
    return image.replace('.png', '_300x.png');
  }
  return image;
};

function RelatedProductsComponent({
  products,
}: Readonly<RelatedProductsComponentProps>) {
  const relatedProducts = products.filter(product => !!product.shopifyProduct);

  return (
    <>
      <h2>Related Products</h2>
      <ProductCardGrid padding="0">
        {relatedProducts.map(({ shopifyProduct, store }) => {
          const { title, variants } = shopifyProduct;
          return (
            <ProductCard
              key={title}
              showFeatureList
              product={{
                ...shopifyProduct,
                variants,
                image: {
                  altText: title,
                  src: getResizedProductImage(store?.previewImageUrl),
                },
              }}
              sanityProduct={{
                store,
              }}
              productTitleAs="h3"
            />
          );
        })}
      </ProductCardGrid>
    </>
  );
}

export default RelatedProductsComponent;
